import { Badge } from "@shared/ui/badge";
import { getStatusBadgeClass } from "@shared/utils/statusUtils";
import { Settings } from "lucide-react";
import React from "react";

export const TemplateHeader: React.FC<any> = ({ template }) => {
  const getBadgeVariant = (status: string) => {
    switch (status) {
      case "active":
        return "default";
      case "inactive":
        return "secondary";
      case "archived":
        return "destructive";
      default:
        return "default";
    }
  };

  const getBadgeClassName = (status: string) => {
    switch (status) {
      case "active":
        return "bg-green-100 text-green-800";
      case "inactive":
        return "bg-gray-100 text-gray-800";
      case "archived":
        return "bg-red-100 text-red-800";
      default:
        return "bg-green-100 text-green-800";
    }
  };

  return (
    <div className="flex items-start justify-between mb-6 p-6 rounded-lg">
      <div className="flex items-start gap-4">
        <div className="p-3 bg-blue-100 rounded-lg">
          <Settings className="h-8 w-8 text-blue-600" />
        </div>
        <div>
          <div className="flex items-center gap-3 mb-2">
            <h1 className="text-2xl font-bold text-gray-900">
              {template?.templateName}
            </h1>
            <Badge className={getStatusBadgeClass(template?.status)}>
              {template?.status}
            </Badge>
          </div>
        </div>
      </div>
      <div className="text-right">
        <p className="text-xs text-gray-500 mb-1">TOTAL BILLS GENERATED</p>
        <p className="text-3xl font-bold text-gray-900">
          {template?.totalBillsGenerated}
        </p>
      </div>
    </div>
  );
};
